import { PUBLIC_SWR_KEYS } from "../Utilities/swrKeys";
import { useCachedSWR } from "../Utilities/useCachedSWR";
export const useAccountSettingsQuery = () => {
    const { data, isLoading } = useCachedSWR(PUBLIC_SWR_KEYS.ACCOUNT_SETTINGS);
    return { accountSettings: data === null || data === void 0 ? void 0 : data.AccountSettings, isLoading };
};
